import { partesAAnthropic, partesAOpenAI } from './ai-provider.partes';

const partes = [
  { type: 'text' as const, text: 'Imagen 1' },
  { type: 'image' as const, jpegBase64: 'QUJD' },
];

describe('partesAAnthropic', () => {
  it('mapea texto e imagen base64 jpeg', () => {
    expect(partesAAnthropic(partes)).toEqual([
      { type: 'text', text: 'Imagen 1' },
      { type: 'image', source: { type: 'base64', media_type: 'image/jpeg', data: 'QUJD' } },
    ]);
  });
});

describe('partesAOpenAI', () => {
  it('mapea texto e imagen como data URL', () => {
    expect(partesAOpenAI(partes)).toEqual([
      { type: 'text', text: 'Imagen 1' },
      { type: 'image_url', image_url: { url: 'data:image/jpeg;base64,QUJD' } },
    ]);
  });
});
